export const type = 'alert.deliveryMethods';
